module.exports = __webpack_public_path__ + "img/down-left-and-up-right-to-center.fa528fc2.svg";